import script from "./AppConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./AppConfirmDialog.vue?vue&type=style&index=0&id=f3b3de7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b3de7e"]])

export default __exports__